
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.111 21c-1.56 0-2.864-1.078-2.962-2.478l-.006-.17V11.56L2.85 13.413a.52.52 0 01-.67-.013l-.066-.07a.534.534 0 01.013-.677l.069-.066 9.476-8.471a.52.52 0 01.568-.057l.086.057 9.476 8.47a.533.533 0 01.082.745.52.52 0 01-.657.135l-.079-.053-2.292-1.853v6.793c0 1.425-1.244 2.557-2.782 2.642l-.186.005H8.11zM12 5.207l-5.81 5.505v7.64c0 .813.758 1.512 1.753 1.583l.168.006h1.27v-3.706l.005-.174c.09-1.38 1.225-2.473 2.614-2.473 1.389 0 2.525 1.092 2.613 2.473l.006.174v3.706h1.27c1.02 0 1.831-.656 1.914-1.454l.006-.134v-7.64L12 5.207zm0 9.44c-.817 0-1.488.63-1.564 1.435l-.007.153v3.706h3.143v-3.706l-.008-.153A1.578 1.578 0 0012 14.647z","fill":"#fff"}})])
          )
        }
      }
    